import React from "react";
import "../Styles/Banners.scss";

const Banner = () => {
  return (
    <section className="hero">
      <div className="hero-inner">
        <div className="hero-content">
          {/* Top Tag Line with Dots */}
          <div className="partner-banner-tag-row">
            <span className="partner-banner-tag">PARTNER CENTER</span>
            <span className="partner-banner-dots">• •</span>
          </div>

          {/* Main Headline */}
          <h1 className="partner-hero-headline-serif">
            Meet Our AI Workforce. <br />
            Intelligence That Moves <br />
            <span className="partner-hero-orange-text">Business Forward.</span>
          </h1>

          {/* Subdescription */}
          <p className="partner-hero-subdescription">
            Explore a connected suite of purpose-built AI platforms for customer engagement, document intelligence, workflow automation, and data-driven decision-making. Get to know EngageAI, DocsAI, and InsightsAI—their capabilities, use cases, business value, and the resources you need to present, position, and promote them with your customers.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Banner;
